import classNames from "classnames";
import { CourseIndexDetailCard } from "components/molecules/CourseIndexTile";
import "./index.scss";

interface IProps {
  segment: null | any;
  theme:"light"|"dark";
}

export const CourseIndexDetailCardSection = ({ segment,theme }: IProps) => {
  return (
    <div className={classNames("course-index-detail-card-section-wrapper")}>
      {segment === null
        ? null
        : segment.LearningTracks.map((learningTrack: any, index: number) => (
            <CourseIndexDetailCard
              key={index}
              borderColor="black"
              isTabShow={true}
              title={learningTrack.Name}
              groupNames={learningTrack.GroupNames}
              groups={learningTrack.Groups}
              drillSmartContent={learningTrack.DrillSmartContent}
              theme={theme}
            />
          ))}
    </div>
  );
};
